var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgExpiredColon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 146,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.187 25.686v24",
  stroke: "#242633",
  strokeWidth: 0.45
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.186 57.686.53 63.343 6.186 69l5.657-5.657-5.657-5.657Zm0 19.314L.53 82.657l5.657 5.657 5.657-5.657L6.186 77Z",
  fill: "#696B78"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.187 96.314v24",
  stroke: "#242633",
  strokeWidth: 0.45
})));
export { SvgExpiredColon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTQ2IiB2aWV3Qm94PSIwIDAgMTIgMTQ2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNi4xODY1MiAyNS42ODYyTDYuMTg2NTIgNDkuNjg2MiIgc3Ryb2tlPSIjMjQyNjMzIiBzdHJva2Utd2lkdGg9IjAuNDUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjE4NjE1IDU3LjY4NjJMMC41MjkyOTcgNjMuMzQzTDYuMTg2MTUgNjguOTk5OUwxMS44NDMgNjMuMzQzTDYuMTg2MTUgNTcuNjg2MlpNNi4xODYxNSA3Ny4wMDAxTDAuNTI5Mjk3IDgyLjY1N0w2LjE4NjE1IDg4LjMxMzhMMTEuODQzIDgyLjY1N0w2LjE4NjE1IDc3LjAwMDFaIiBmaWxsPSIjNjk2Qjc4Ii8+CjxwYXRoIGQ9Ik02LjE4NjUyIDk2LjMxMzhMNi4xODY1MiAxMjAuMzE0IiBzdHJva2U9IiMyNDI2MzMiIHN0cm9rZS13aWR0aD0iMC40NSIvPgo8L3N2Zz4K";